import { COLOR_PALETTE } from 'constants/ui';

const SWATCH_SIZE = 28;

const GRID_COLUMNS = 10;

const GRID_GAP = 6;

export const popoverPaperStyles = {
  padding: '16px',
  borderRadius: '8px',
};

export const gridContainerStyles = {
  display: 'grid',
  gridTemplateColumns: `repeat(${GRID_COLUMNS}, ${SWATCH_SIZE}px)`,
  gap: `${GRID_GAP}px`,
};

export const getSwatchStyles = ({ bg, isSelected }) => ({
  width: SWATCH_SIZE,
  height: SWATCH_SIZE,
  minWidth: SWATCH_SIZE,
  borderRadius: '4px',
  backgroundColor: bg,
  border: isSelected ? `2px solid ${COLOR_PALETTE.BRAND[6]}` : '2px solid transparent',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  '&:hover': {
    opacity: 0.8,
  },

  '& svg': {
    color: 'background.primary',
  },
});

export const triggerBoxStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  borderRadius: ({ shape }) => shape.radius.l,
  padding: '8px 14px',
  minHeight: '40px',
  boxSizing: 'border-box',
  '&:hover': {
    borderColor: COLOR_PALETTE.GRAY[7],
  },
};

export const getTriggerSwatchStyles = bg => ({
  width: 24,
  height: 24,
  minWidth: 24,
  borderRadius: '4px',
  backgroundColor:
    bg ||
    (({ palette }) =>
      palette.mode === 'dark' ? palette.background.secondary : COLOR_PALETTE.GRAY[4]),
  border: ({ palette }) => `1px solid ${palette.border.input}`,
});
